module.exports = __webpack_public_path__ + "static/img/8.9e9e577.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/8.png
// module id = 8aVN
// module chunks = 0